<template>
    <header id="Header" class="relative z-[666]" :class="[css.container, dark && css.dark, dark && 'dark']">
        <div :class="css.main" class="relative z-[1] bg-white">
            <div class="container flex items-center h-[64px] max-lg:h-[60px] max-xl:!w-full max-xl:!min-w-full max-xl:px-[64px]">
                <!-- * Logo 容器 -->
                <div class="flex items-center">
                    <!-- * RDDC联盟 Logo -->
                    <ProjectRoute :to="$i18n.locale == 'zh' ? 'https://www.cyagen.cn/' : 'https://www.cyagen.com/us/en/'">
                        <img class="object-cover h-[27px] max-lg:h-[26px]" :src="logos.cyagen" alt="Cyagen" />
                    </ProjectRoute>
                    <!-- * 分割线 -->
                    <div :class="css.division" class="w-[1px] h-[16px] mx-[12px] bg-default"></div>
                    <!-- * RDDC Logo -->
                    <ProjectRoute to="http://www.tsinghua-gd.org/" target="_self">
                        <img class="object-cover h-[36px]" :src="logos.tsinghua" alt="Tsing hua" />
                    </ProjectRoute>
                </div>

                <!-- * 导航列表 -->
                <HeaderNavigator />

                <!-- * 搜索组件 -->
                <SearchControl class="module-search" />

                <!-- * 用户模块 -->
                <div class="flex-center mx-[18px] max-lg:mx-[8px]">
                    <!-- * 登录按钮 -->
                    <div
                        :class="css.user"
                        class="cursor-pointer p-[4px] flex items-center text-[16px] hover:text-main"
                        @click="methods.login"
                        v-if="!user.id">
                        {{ $t("LogIn") }}<span class="px-[8px]">|</span>{{ $t("SignUp") }}
                    </div>
                    <!-- * 用户头像 -->
                    <ProjectRoute class="flex-center" :to="{ name: 'UserLayout' }" v-else>
                        <img class="w-[32px] h-[32px] rounded-[50%] object-cover" :src="user.avatar" alt="User Avatar" />
                    </ProjectRoute>
                </div>

                <!-- * 语言控制器 -->
                <UiTooltip direction="bottom" align="center" class="h-full" :z-index="68">
                    <template #content>
                        <ProjectRoute
                            class="flex items-center text-[14px] leading-[30px] text-center hover:underline hover:text-main"
                            :to="routes[value.key]"
                            :language="value.key"
                            target="_parent"
                            v-for="value in language.options">
                            <img :src="value.src" />
                            <span class="ml-[8px]">{{ value.name }}</span>
                        </ProjectRoute>
                    </template>
                    <div :class="css.language" class="h-full p-[4px] flex items-center justify-center cursor-pointer text-[16px] hover:text-main">
                        <img :src="language.curr?.src" />
                        <span class="ml-[8px]">{{ language.curr?.name }}</span>
                        <ui-icon class="ml-[2px]" name="arrow/entity" />
                    </div>
                </UiTooltip>
            </div>
        </div>
    </header>
</template>

<script lang="ts" setup>
//* 组件库
import { UiIcon, UiTooltip } from "various-ui";
//* 私有组件
import HeaderNavigator from "./components/navigation/index.vue";
import SearchControl from "./components/search-control/index.vue";
//* 组件属性
import { ComponentPropsOption } from "./index";
import { useComposable } from "./src/composable";
//* 样式
import css from "./index.module.less";

//* 组件属性注册
const define = defineProps(ComponentPropsOption);
//* 持久化数据注册
const user = useUserStore();
//* 插件
const route = useRoute();
//* 组合函数
const { vars, computeds, methods } = useComposable(define);
const { logos, routes, language } = computeds;
</script>
